import {ChangeDetectionStrategy, Component, Input, OnChanges, SimpleChanges} from '@angular/core';
import {ProjectCountData} from '../../../shared/types/nso-data-portal/dashboard-data';
import {Observable} from 'rxjs';
import {environment} from '../../../../environments/environment';
import {share} from 'rxjs/operators';
import {LiveCountTransformedData} from '../../../shared/types/nso-data-portal/live-count-data';
import {ScoutDonateRestService} from '../../../shared/services/nso-data-portal/rest-services/scout-donate/rest/scout-donate-rest.service';
import {SearchEntityLevels} from '../../../shared/types/nso-data-portal/search-entity-levels';
import {LiveCountService} from '../../../shared/services/nso-data-portal/rest-services/scout-donate/live-count/live-count.service';
import {EntityInformationRestService} from '../../../shared/services/nso-data-portal/rest-services/entity-information-rest.service';

@Component({
  selector: 'wsd-projects-count',
  templateUrl: './projects-count.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['./projects-count.component.css']
})
export class ProjectsCountComponent implements OnChanges {

  @Input()
  organizationId: number;

  @Input()
  organizationName: string;

  @Input()
  entityLevel: SearchEntityLevels;

  gsWebLink: string;

  projectCount$: Observable<ProjectCountData>;

  liveData$: Observable<LiveCountTransformedData>;

  constructor(private sdpService: ScoutDonateRestService,
              private liveCountService: LiveCountService,
              private entityService: EntityInformationRestService) {
  }

  ngOnChanges(changes: SimpleChanges) {

    this.projectCount$ =
      this.entityService.getProjectCount({
        entityId: this.organizationId,
        level: this.entityLevel
      }).pipe(share());

    this.gsWebLink = environment.gsWebUrl
      .concat(`/service-requests?organizationId=${this.organizationId}`);

    this.liveData$ = this.liveCountService.getLiveCountData({
      entityLevel: this.entityLevel,
      entityId: this.organizationId,
      orgName: this.organizationName
    }).pipe(share());
  }

}
